import { action } from "satcheljs";
import type { OpenPstScenario } from "../store/schema/OpenPstFileExperienceStore";
import type { AccountConfigDialogLaunchOrigin } from "owa-account-config-shared";
import type { MailboxInfo } from "owa-client-types";

/**
 * Dispatch this action to render the remediation experience to attempt to
 * get the given PST account into a healthy state
 */
export interface RemediatePstAccountActionMessage {
    scenario: OpenPstScenario;
    mailboxInfo: MailboxInfo;
    targetWindow: Window;
    entryPoint: AccountConfigDialogLaunchOrigin | undefined;
}
export const remediatePstAccount: (mailboxInfo: MailboxInfo, targetWindow: Window, entryPoint?: AccountConfigDialogLaunchOrigin) => RemediatePstAccountActionMessage = action("remediatePstAccount", (mailboxInfo: MailboxInfo, targetWindow: Window, entryPoint?: AccountConfigDialogLaunchOrigin): RemediatePstAccountActionMessage => ({
    scenario: "RemediatePstAccount" as OpenPstScenario,
    mailboxInfo,
    targetWindow,
    entryPoint,
}));
